/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Rolechangessaved2Inputs */

const en_settings_collaborators_rolechangessaved2 = /** @type {(inputs: Settings_Collaborators_Rolechangessaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role changes saved successfully`)
};

/**
* | output |
* | --- |
* | "Role changes saved successfully" |
*
* @param {Settings_Collaborators_Rolechangessaved2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_rolechangessaved2 = /** @type {((inputs?: Settings_Collaborators_Rolechangessaved2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Rolechangessaved2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_rolechangessaved2(inputs)
});
export { settings_collaborators_rolechangessaved2 as "settings_collaborators_roleChangesSaved" }